<script setup lang="ts">
import { showConfirmDialog, showLoadingToast } from "vant";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useTask } from "@/stores/task";
import { encodeEnvFromPoses, checkMatesHasGirlOrBoy } from "./Tabs/initStyle";
import { getInitPromptJson } from "@/modules/common";
import { useGlobalUser } from "@/stores/globalUser";

import NSFWModalConfirmAge from "@/views/NSFW/Modal/NSFWModalConfirmAge.vue";
import { StorageGet, StorageSet } from "@/tools/localStorage";

// State
const loadingPrompts = ref(false);
const userStore = useGlobalUser();

const { t } = useI18n();
// 画面风格
// 新建特征引导
const showCreateTraitGuide = ref(false);

// Lifecycle
const taskNewStore = useTask();
const isMutiMode = ref(false); // 0 单人  1 多人
const reqData = ref<PromptJson>(getInitPromptJson());
const onConfirmGenImage = async (isConfirm?: boolean) => {
  let loadingToast: any;

  if (!reqData.value.isUnlimited && !isConfirm)
    return (showNormalConfirmModal.value = true);

  try {
    if (isMutiMode.value) {
      reqData.value.mateTraitId = undefined;
      const name = checkMatesHasGirlOrBoy(reqData.value.mates!);
      if (name) {
        try {
          await showConfirmDialog({
            message: t(`painting.muti.noGirlOrBoyTips`, { name }),
            confirmButtonText: t("painting.muti.continue"),
            cancelButtonText: t("Buttons.cancel"),
          });
        } catch (e) {
          return;
        }
      }

      encodeEnvFromPoses(reqData.value);
    } else reqData.value.mates = undefined;
    loadingToast = showLoadingToast({
      duration: 0,
      message: t("Message.preparingImage"),
    });
    await taskNewStore.createTask(reqData.value);
    userStore.refreshUser();
  } catch (e: any) {
    console.log(e);
  } finally {
    loadingToast && loadingToast.close();
  }
};

const showNormalConfirmModal = ref(false);

const onOpenLimited = () => {
  if (reqData.value.isUnlimited) {
    if (reqData.value.env.media?.isNsfw)
      return showConfirmDialog({
        message: t("painting.envIsNsfwCannotCloseNsfw"),
        confirmButtonText: t("Buttons.confirm"),
        cancelButtonText: t("Buttons.cancel"),
      });

    return (reqData.value.isUnlimited = false);
  }
  if (!userStore.user.isAdult) return (showConfirmAge.value = true);
  return onAgeConfirm();
};

const onAgeConfirm = async () => {
  if (!StorageGet(`painting.nsfwNotice`)) {
    try {
      await showConfirmDialog({
        message: t("painting.nsfwNotice"),
        confirmButtonText: t("Buttons.confirm"),
        cancelButtonText: t("Buttons.cancel"),
      });
      StorageSet(`painting.nsfwNotice`, 1);
    } catch (e) {
      return false;
    }
  }
  reqData.value.isUnlimited = true;
  if (!reqData.value.customStyle?.version)
    reqData.value.customStyle = { version: 2, prompt: "" };
  return true;
};

const showConfirmAge = ref(false);

const uploadNsfwImage = async (media: Media) => {
  const isOpen = await onOpenLimited();
  if (isOpen) {
    reqData.value.env.media = {
      id: media.id,
      url: media.url,
      isNsfw: 1,
    };
    reqData.value.env.mediaId = media.id;
  }
};
</script>
<template>
  <div class="h-full grid grid-rows-[auto_1fr]">
    <!-- 顶部导航 -->
    <threads-nav :show-back="true" :show-center="false">
      <template #right>
        <template v-if="!loadingPrompts && !userStore.isCNUser">
          <i class="iconfont icon-heart-fill text-[#F75ECC] text-2xl"></i>

          <VanSwitch
            :model-value="reqData.isUnlimited"
            @update:model-value="onOpenLimited"
            active-color="#F75ECC"
            size="14px"
          />
        </template>
        <button
          v-if="!loadingPrompts"
          :class="[
            'btn  btn-sm rounded',
            reqData.isUnlimited ? 'btn-private' : 'btn-primary',
          ]"
          @click="onConfirmGenImage(false)"
        >
          <i class="iconify mingcute--pic-line"></i>
          {{ $t("Buttons.generate") }}
        </button>
      </template>
    </threads-nav>
    <div
      v-if="loadingPrompts"
      class="h-full flex flex-grow items-center justify-center"
    >
      <div class="loading"></div>
    </div>
    <ImageMutiTraitTabs
      v-else
      :req-data="reqData"
      v-model:is-muti-mode="isMutiMode"
      @upload-nsfw-image="uploadNsfwImage"
      :show-tabs="['origin', 'style', 'setting']"
    />

    <create-trait-guide v-model:show="showCreateTraitGuide" />

    <!-- 年龄限制 -->
    <NSFWModalConfirmAge
      v-model:show="showConfirmAge"
      @enter="(showConfirmAge = false), onAgeConfirm()"
    />

    <!-- 能量块消耗 -->
    <ImageModalPowerCubeConfirm
      v-model:show="showNormalConfirmModal"
      :req-data="reqData"
      @generate="onConfirmGenImage(true)"
    />
  </div>
</template>
